import { nullSafeIsEquivalent } from '@angular/compiler/src/output/output_ast';
import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-request-list',
  templateUrl: './request-list.component.html',
  styleUrls: ['./request-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RequestListComponent implements OnInit {

  requests: any[] = [];

  constructor(public router: Router) { }

  ngOnInit(): void {

    this.requests.push({
      title: "Merkez Depodan Bölge Depolara Talep",
      description: 'Talep edilen ürünler bölge depolara teslim edilir.',
      uri: '/loads/stock-transfer-warehouses',
      params: null,
      disabled: false
    })

    this.requests.push({
      title: "Satış Noktasına Talep",
      description: 'Talep edilen ürünler seçmiş olduğunuz satış noktası / mağazaya teslim edilir.',
      uri: '/loads/create-request',
      params: {type: 'toSalePoint'},
      disabled: false
    })

    this.requests.push({
      title: "Depodan Teslim Alınacak Talepler",
      description: 'Talep edilen ürünler depodan teslim alınır.',
      uri: '/loads/create-request',
      params: {type: 'fromWarehouse'},
      disabled: false
    })

  }

}
